import { ProfileNavigation } from '@archipro-design/aria';
import type { ProfileNavigationItemProps } from '@archipro-design/aria';

import { useFilterStates } from './use-magazine-filter-states';
import type { CategoryFilterSectionProps } from './FilterSection';
import { DigitalMagazineOptions } from '~/modules/magazine/configs/constants';
import { getUrlByFilterStates } from '../../util/get-magazine-enum-by-key';
import { Link } from '@remix-run/react';
import { useState } from 'react';
import FilterDrawerMobile from './FilterDrawer.mobile';
import React from 'react';
import { useHydrated } from 'remix-utils';
import { useIsomorphicLayoutEffect } from 'ahooks';

const scrollOptions: ScrollIntoViewOptions = {
    behavior: 'smooth',
    block: 'nearest',
    inline: 'center',
};

export const FilterSectionMobile = ({
    initialStates,
}: CategoryFilterSectionProps) => {
    const [openFilterDialog, setOpenFilterDialog] = useState(false);
    const navRef = React.useRef<HTMLDivElement>(null);
    const hydrated = useHydrated();
    const result = useFilterStates({
        initialStates,
        active: true,
    });

    const { filterStates, appliedFilters } = result;

    const navItems: ProfileNavigationItemProps[] = DigitalMagazineOptions.map(
        (o, i) => ({
            children: o.label,
            selected:
                filterStates.categoryEnum === o.searchEnum ||
                (!o.searchEnum && !filterStates.categoryEnum),

            as: Link,
            to: getUrlByFilterStates({
                ...filterStates,
                categoryEnum: o.searchEnum ?? null,
            }),
            onClick: (e) => {
                (e.target as Element).scrollIntoView(scrollOptions);
                setActiveIndex(i);
            },
        }),
    );

    const currentIndex = navItems.findIndex((item) => item.selected);

    const [activeIndex, setActiveIndex] = useState(currentIndex);

    React.useEffect(() => {
        setActiveIndex(currentIndex);
    }, [currentIndex]);

    useIsomorphicLayoutEffect(() => {
        if (hydrated) {
            const activeLink = navRef.current?.querySelector(
                `a:nth-child(${activeIndex + 1})`,
            );
            if (activeLink) {
                activeLink.scrollIntoView(scrollOptions);
            }
        }
    }, [hydrated, activeIndex]);

    return (
        <div>
            <ProfileNavigation
                ref={navRef}
                items={navItems.map((item, i) => ({
                    ...item,
                    selected: i === activeIndex,
                }))}
                filterButton={{
                    children: `Filters ${
                        appliedFilters.length
                            ? `(${appliedFilters.length})`
                            : ''
                    }`,
                    onClick: () => setOpenFilterDialog(true),
                }}
            />
            <FilterDrawerMobile
                controlledStates={result}
                isOpen={openFilterDialog}
                toggleOpen={setOpenFilterDialog}
            />
        </div>
    );
};
